
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getHistoryMessage } from "@/api/api-basic-websocket";
import msgListDiv from "../../data-config/components/msg-list-div.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-msg-list-div": msgListDiv
  }
})
export default class CollectionChargingOperation extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private msgList!: object[];
  @Prop({
    default: () => {
      return [];
    }
  })
  private type!: object[];
  @Prop({
    default: () => {
      return {};
    }
  })
  private formInline!: objAny;
  @Watch("msgList")
  getVisible() {
    // this.initEchart();
    this.$nextTick(() => {
      this.getList();
    });
  }
  private isAll = false;
  private msgType = 1;
  private hisMsgList: object[] = [];
  private msgListShow: object[] = [];
  private form: objAny = {
    endTime: "",
    msgCodes: [],
    pageIndex: 1,
    pageSize: 10,
    sn: "",
    startTime: ""
  };
  public clearMsg() {
    this.$emit("clearMsg");
  }
  public timeChange(val: string[]) {
    this.form.startTime = val[0];
    this.form.endTime = val[1];
  }
  public queryClick() {
    if (!this.form.startTime || this.form.startTime == "") {
      this.$Message.error(i18n.t("formText.selectTimePl"));
    } else {
      this.isAll = false;
      this.form.pageIndex = 1;
      this.hisMsgList = [];
      this.getHistoryMessage();
    }
  }

  public getList() {
    const msgList: object[] = [];
    this.msgList.map((item: objAny) => {
      if (this.type.indexOf(item.msgCode) != -1) {
        msgList.push(item);
      }
    });
    this.msgListShow = msgList;
  }

  async getHistoryMessage() {
    this.form.msgCodes = this.type;
    this.form.pilePkId = this.formInline.pilePkId;
    this.form.sn = this.formInline.pilePkId;
    // this.form.msgCodes = [1020];
    // this.form.sn = "202007140003";
    const ret = await getHistoryMessage(this.form);
    if (ret.status == this["$config"].apiStatus) {
      const list: object[] = ret.data || [];
      this.hisMsgList = this.hisMsgList.concat(list);
      if (this.hisMsgList >= ret.total) {
        this.isAll = true;
      }
    }
  }

  public loadingMore() {
    this.form.pageIndex++;
    this.getHistoryMessage();
  }
}
